import { SHAPE_COMPONENTS } from './shapes';
import type { ShapeData } from './types';

const VALID_SHAPE_KINDS = Object.keys(SHAPE_COMPONENTS) as (keyof typeof SHAPE_COMPONENTS)[];

export function isValidData(value: unknown): value is ShapeData {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.shapeKind === 'string' && VALID_SHAPE_KINDS.includes(v.shapeKind as never) &&
    (typeof v.fill === 'string') &&
    typeof v.stroke === 'string' &&
    (v.strokeWidth === 1 || v.strokeWidth === 2 || v.strokeWidth === 4) &&
    (v.strokeStyle === 'solid' || v.strokeStyle === 'dashed' || v.strokeStyle === 'dotted') &&
    typeof v.cornerRadius === 'number' &&
    (v.text === null || typeof v.text === 'string' || typeof v.text === 'object') &&
    (v.textAlign === 'left' || v.textAlign === 'center' || v.textAlign === 'right') &&
    typeof v.fontSize === 'number'
  );
}
